import React from 'react';
import App from 'next/app';
import { InstantSearch } from '../utils/reactInstantsearchCompat';
import { getSearchClient } from '../adapters/algolia/client';
import '../static/styles/font-face.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/index.scss';
class CustomApp extends App {
    constructor(props) {
        super(props);
        this.state = {
            isInstantSearchReady: false,
            searchClient: null,
        };
    }

    componentDidMount() {
        let searchClient = null;

        try {
            searchClient = getSearchClient();
        } catch (error) {
            searchClient = null;
        }

        this.setState({
            isInstantSearchReady: true,
            searchClient,
        });
    }

    render() {
        const { Component, pageProps } = this.props;
        const pageContent = <Component {...pageProps} />;

        const appContent = this.state.isInstantSearchReady && this.state.searchClient
            ? (
                <InstantSearch searchClient={this.state.searchClient} indexName={process.env.ALGOLIA_INDEX}>
                    {pageContent}
                </InstantSearch>
            )
            : pageContent;
        return appContent;
    }
}

export default CustomApp;
